module.exports = __webpack_public_path__ + "static/media/symbol.979182cf.svg";